import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "absolute-full column flex-center transparent image-gallery-item--error" }
const _hoisted_2 = { class: "text-error" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center text-subtitle2"
}

import { Notify } from "quasar"
import { IMG_PLACEHOLDER } from "src/util/constants/files"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { deleteImage } from "src/util/functions/dialogs"
import { showImageView, showPhotoGalleryOverlay } from "src/util/functions/overlays"
import { ImageGalleryItem } from "src/util/types/components/sfxImageGallery"
import { AttachmentContext } from "src/util/types/dataModels/attachment"
import { computed, PropType } from "vue"

//region Props and Emits

const imageSize = "56px"

//endregion

//region Functions


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxImageGallerySmall',
  props: {
  imageSrc: {
    type: Array as PropType<Array<ImageGalleryItem>>,
    required: true,
  },

  canDelete: {
    type: Boolean,
    default: false,
  },

  entityId: {
    type: String,
  },

  entityType: {
    type: String as PropType<AttachmentContext>,
  },

  disableEditImage: Boolean,
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const imageList = computed(() => props.imageSrc.slice(0, 4))
const imageListRemainder = computed(() => props.imageSrc.slice(4))
async function handleImageClick(image: ImageGalleryItem) {
  if (process.env.IS_MANAGER_MODE && props.entityId && props.entityType) {
    await showPhotoGalleryOverlay(props.entityId, props.entityType, props.disableEditImage)
  } else {
    showImageView(image, props.imageSrc)
  }
}

async function requestDeletion(image: ImageGalleryItem) {
  if (props.canDelete) {
    const data = await deleteImage()

    if (data) {
      Notify.create({
        message: `Request for removal of: ${image.attachmentData.name}, because: ${data}`,
        progress: true,
        color: "positive",
      })
    }
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_touch_hold = _resolveDirective("touch-hold")!

  return (_openBlock(), _createBlock(_component_q_list, { class: "row no-wrap scroll image-gallery full-width" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "image-gallery-item"
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_q_img, {
            src: image.src,
            "placeholder-src": _unref(IMG_PLACEHOLDER),
            onClick: ($event: any) => (handleImageClick(image)),
            width: imageSize,
            height: imageSize,
            ratio: "1",
            class: "image-gallery-item--image"
          }, {
            error: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_icon, {
                  name: _unref(Icons).IMAGE_ERROR,
                  class: "text-disabled",
                  size: "25px"
                }, null, 8, ["name"]),
                _createElementVNode("i", _hoisted_2, _toDisplayString(_ctx.$t("sfxImage.no_image_small")), 1)
              ])
            ]),
            _: 2
          }, 1032, ["src", "placeholder-src", "onClick"])), [
            [
              _directive_touch_hold,
              () => requestDeletion(image),
              void 0,
              { mouse: true }
            ]
          ])
        ]))
      }), 128)),
      (imageListRemainder.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " +" + _toDisplayString(imageListRemainder.value.length), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})